import { render, staticRenderFns } from "./weapon.vue?vue&type=template&id=043ba451&scoped=true"
import script from "./weapon.vue?vue&type=script&lang=js"
export * from "./weapon.vue?vue&type=script&lang=js"
import style0 from "./weapon.vue?vue&type=style&index=0&id=043ba451&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043ba451",
  null
  
)

export default component.exports